<div #container [ngClass]="{'p-carousel p-widget p-widget-content p-corner-all':true}" [ngStyle]="style" [class]="styleClass">
  <div class="p-carousel-header p-widget-header p-corner-all">
      <span class="p-carousel-header-title">{{headerText}}</span>
      <span class="p-carousel-button p-carousel-next-button pi pi-arrow-circle-right" (click)="onNextNav()" 
              [ngClass]="{'p-state-disabled':(page === (totalPages-1)) && !circular}" *ngIf="value&&value.length"></span>
      <span class="p-carousel-button p-carousel-prev-button pi pi-arrow-circle-left" (click)="onPrevNav()" 
              [ngClass]="{'p-state-disabled':(page === 0 && !circular)}" *ngIf="value&&value.length"></span>
      <div *ngIf="displayPageLinks" class="p-carousel-page-links">
          <a href="#" (click)="setPageWithLink($event,i)" class="p-carousel-page-link pi" *ngFor="let links of anchorPageLinks;let i=index" [ngClass]="{'pi-circle-on': page===i, 'pi-circle-off': page !== i}"></a>
      </div>
      <select *ngIf="displayPageDropdown" class="p-carousel-dropdown p-widget p-state-default p-corner-left" [value]="page" (change)="onDropdownChange($event.target.value)">
          <option *ngFor="let option of selectDropdownOptions" [value]="option" [selected]="value == option">{{option+1}}</option>
      </select>
      <select *ngIf="responsive&&value&&value.length" class="p-carousel-mobiledropdown p-widget p-state-default p-corner-left" [value]="page" (change)="onDropdownChange($event.target.value)"
          [style.display]="shrinked ? 'block' : 'none'">
          <option *ngFor="let option of mobileDropdownOptions" [value]="option" [selected]="value == option">{{option+1}}</option>
      </select>
  </div>
  <div #viewport class="p-carousel-viewport">
      <ul #items class="p-carousel-items" [style.left.px]="left" [style.transitionProperty]="'left'" 
                  [style.transitionDuration]="effectDuration" [style.transitionTimingFunction]="easing">
          <li *ngFor="let item of value" class="p-carousel-item p-widget-content p-corner-all">
              <ng-container *ngTemplateOutlet="itemTemplate; context: {$implicit: item}"></ng-container>
          </li>
      </ul>
  </div>
</div>
